import { useLocation } from 'react-router-dom';
import LegadoPostDonation from 'src/containers/legado/LegadoPostDonation';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import UtilitiesService from 'src/services/api/utilitiesService';
import { filterList } from 'src/services/contextProviders/lists/listsApiCall';
import { useState } from 'react';

const TotalChurchComp = styled.div`
  position: relative;
  background-color: white;

  .container {
    .top-section {
      margin-top: 20px;
    }
    .progress-container {
      margin-bottom: 100px;
    }
  }

  .go-back-btn {
    position: absolute;
    top: 10px;
    left: 100px;
    align-self: flex-start;
    margin-left: 0;
    margin-bottom: 1rem;
    background: transparent;
    color: #1e3a8a;
    border: 1px solid #1e3a8a;
    border-radius: 16px;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 4px 14px;
    cursor: pointer;
    z-index: 200;
    transition: background 0.2s, color 0.2s;
    margin-top: 20px;
  }
  .go-back-btn:active {
    background: #e6eaff;
    color: #2746b3;
  }
`;

const LegadoPostDonationTotalChurch = (props) => {
  const { setCategory } = props;
  const location = useLocation();
  const [data, set_data] = useState([]);

  useEffect(() => {
    UtilitiesService.getList()
      .then((response) => {
        if (response.data.success) {
          set_data?.(filterList(response.data.lists, 'data'));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const milestones = [
    {
      number: 1000,
      description: '1000 Personas nuevas conociendo a Jesús',
    },
    {
      number: 2000,
      description: '2000 Personas nuevas conociendo a Jesús',
    },
    {
      number: 3000,
      description: '3000 Personas nuevas conociendo a Jesús',
    },
    {
      number: 4000,
      description: '4000 Personas nuevas conociendo a Jesús',
    },
    {
      number: 5000,
      description: '5000 Personas nuevas conociendo a Jesús',
    },
  ];

  const totalChairs = data?.find((item) => item.name === 'legado')?.key || 0;

  return (
    <TotalChurchComp>
      {location.pathname === '/legado' && (
        <button className="go-back-btn" onClick={() => setCategory('general')}>
          Volver
        </button>
      )}
      <LegadoPostDonation
        progress={(parseInt(totalChairs) / 5000) * 100}
        title="Así vamos"
        milestones={milestones}
      />
    </TotalChurchComp>
  );
};

export default LegadoPostDonationTotalChurch;
